import {
  decorate,
  observable,
  action,
  configure,
  runInAction,
  reaction,
} from 'mobx';
import Cookies from 'js-cookie';
import { setStoredValue } from 'shared/utils/localStorage';
import history from '../browserHistory';

configure({ enforceActions: 'always' });

/**
 * Created for NPA secure. Needs rewriting but thought I'd leave it in as a starting points
 * */

export default class AuthStore {
  constructor() {
    runInAction('AuthStore', () => {
      this.errorMessage = null;
      this.settings = null;
    });

    reaction(
      () => this.settings,
      () => setStoredValue('simulcast_session', this.settings.sessionToken),
    );
  }

  setSettings = (data) => {
    this.settings = data;
  };

  getSession = () => {
    const jwt = Cookies.get('__session');

    let session;
    try {
      if (jwt) {
        // TODO
        /** We need to check the validity of the session token here */
        session = jwt;
      }
    } catch (error) {
      console.error(error);
    }
    return session;
  };

  logOut = () => {
    Cookies.remove('__session');
    history.push('/login');
  };

  setProperty = (key, val) => {
    this[key] = val;
  };
}

decorate(AuthStore, {
  errorMessage: observable,
  getSession: action,
  setSyncID: action,
  logOut: action,
  setProperty: action,
  settings: observable,
  setSettings: action,
});
